import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'project',
		title: 'global.project',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'site',
		title: 'global.site',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'creationDate',
		title: 'global.creationDate',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'serialNumber',
		title: 'global.serialNumber',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'unit',
		title: 'global.unit',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'place',
		title: 'global.place',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'countryCode',
		title: 'global.country',
		sortable: true,
		type: 'shortText',
		defaultVisible: true,
	},
	{
		accessor: 'organization',
		title: 'global.organization',
		type: 'shortText',
		defaultVisible: false,
		sortable: true,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		type: 'shortText',
		defaultVisible: false,
		sortable: true,
	},
	{
		type: 'meterpointsActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
